<div class="Pagination">
  <div class="Pagination__Info">
    {{currentPage}} {{ 'common.of' | translate }} {{totalPages}}
  </div>
  <div class="Pagination__Controls">
    <button class="btn Controls__BtnPrevious"
            [disabled]="currentPage <= 1"
            (click)="onBackClicked()">
      <i class="fas fa-caret-left"></i>
    </button>
    <button class="btn Controls__BtnNext"
            [disabled]="currentPage == totalPages || totalPages == 0"
            (click)="onNextBtnClicked()">
      <i class="fas fa-caret-right"></i>
    </button>
  </div>
</div>
